import React, { useState, useContext } from 'react'
import AgreementRow from './agreement-row/agreement-row'
import Spinner from './../spinner/spinner'
import DashboardContext from '../layout/dashboard-context'
import MessageContext from '../message/message-context'
import api from '../../api'

interface AgreementRowProps {
  collectiveAgreements: Array<{
    [key: string]: string
  }>
  lastReportedYear: Array<{
    collectiveAgreement: string
    numEmployees: number
  }>
  thisYearsData: Any
  setThisYearsData: Any
  setCurrentYearReported: (currentYearReported: boolean) => void
  setSuccess: (success: boolean) => void
}

const AgreementForm = ({
  collectiveAgreements,
  lastReportedYear,
  thisYearsData,
  setThisYearsData,
  setSuccess,
  setCurrentYearReported,
}: AgreementRowProps) => {
  const [loading, setLoading] = useState(false)
  const [sendReport, setSendReport] = useState(false)
  const { selectedOrganization } = useContext(DashboardContext)
  const { setErrorMessage } = useContext(MessageContext)

  const postNewData = async () => {
    if (sendReport) {
      setLoading(true)
      try {
        await createAgreementData()
      } catch (e) {
        setErrorMessage('Något gick fel var god och försök igen')
      }
      setCurrentYearReported(true)
      setLoading(false)
      setSendReport(false)
      setSuccess(true)
    } else {
      setSendReport(true)
    }
  }

  const createAgreementData = async () => {
    try {
      const dataObject = {
        data: [
          {
            numEmployees: 0,
            collectiveAgreement: '',
          },
        ],
        year: thisYearsData.year,
      }

      dataObject.data = thisYearsData.data.filter((tyd) => tyd.numEmployees)

      const res = await api.post(`/accounts/${selectedOrganization.id}/kpi`, dataObject)

      if (res.status !== 200) {
        setErrorMessage('Något gick fel var god och försök igen')
        return []
      }
      
      return res.data
    } catch (e) {
      setErrorMessage('Något gick fel var god och försök igen')
      return []
    }
  }

  return (
    <div className="w-full">
      <div className="relative flex flex-col gap-4 max-width-700">
        <div className="absolute top-0 right-0">
          <span className="label">Föregående år</span>
        </div>
        {Object.keys(collectiveAgreements).map((collectiveAgreementKey, index) => {
          if (collectiveAgreementKey !== '') {
            let prevNumEmployees = 0
            if (lastReportedYear) {
              const tempPrevNumEmployees = lastReportedYear.find(
                (element) => element.collectiveAgreement === collectiveAgreementKey,
              )
              prevNumEmployees =
                tempPrevNumEmployees && tempPrevNumEmployees.numEmployees !== null
                  ? tempPrevNumEmployees.numEmployees
                  : 0
            }
            const numEmployees = 0
            const data = {
              collectiveAgreementLabel: collectiveAgreements[collectiveAgreementKey],
              collectiveAgreement: collectiveAgreementKey,
              numEmployees: numEmployees,
              prevNumEmployees: prevNumEmployees,
            }
            return (
              <AgreementRow
                key={index}
                data={data}
                thisYearsData={thisYearsData}
                setThisYearsData={setThisYearsData}
              />
            )
          }

          return null
        })}
      </div>
      <div className="self-end flex flex-row py-2">
        {loading ? (
          <div>
            <Spinner />
          </div>
        ) : (
            <button className="btn mt-12 btn-long" onClick={() => postNewData()}>
              {sendReport ? 'Är du säker på att du vill lämna in?' : 'Lämna in antal anställda'}
            </button>
        )}
      </div>
    </div>
  )
}

export default AgreementForm
